module.exports = __webpack_public_path__ + "img/1.eb9bf5e.png";